import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDynamic } from "../../../hooks/DynamicProvider";
import FrameCanvas from "../../../components/FrameCanvas";
import logo from "../../../assets/images/onboarding/logo-white.png";
import "./rxg.css";

const RXG = ({ containerHeight, containerWidth }) => {
  const { userInfo } = useDynamic();
  const navigate = useNavigate();
  const frames = Array.from(
    { length: 91 },
    (_, i) => `../assets/images/coin/${(i + 1).toString().padStart(4, "0")}.png`
  );
  const [copyStatus, setCopyStatus] = useState(false);

  const handleCopy = async (copyText) => {
    try {
      await navigator.clipboard.writeText(copyText);
      setCopyStatus(true);
    } catch (error) {
      setCopyStatus(false);
    }
  };

  const purchaseRXG = () => {
    navigate("/ico");
  };

  return (
    <div className="rxg w-100">
      <div className="rxg-left flex-grow-1">
        <div className="text-start w-100">
          <img className="section-logo" src={logo} alt="logo" />
        </div>
        <div className="d-flex align-items-center jusitfy-content-center h-100">
          <FrameCanvas
            frames={frames}
            width={
              containerHeight / 2 > containerWidth * 0.8
                ? containerWidth * 0.8
                : containerHeight / 2
            }
            height={
              containerHeight / 2 > containerWidth * 0.8
                ? containerWidth * 0.8
                : containerHeight / 2
            }
          />
        </div>
        <button
          className="btn btn-primary bg-white w-100"
          onClick={() => {
            purchaseRXG();
          }}
        >
          Purchase RXG
        </button>
      </div>
      <div className="rxg-right d-flex align-items-center justify-content-center flex-grow-1 flex-column">
        <a onClick={() => navigate("/hub")}>
          Explore Hub <i className="fa fa-arrow-right" />
        </a>

        {userInfo?.share_link && (
          <div className="w-full mt-4">
            <p style={{ color: "#346df6" }}>
              Please share the below link with your friend&nbsp;
              {copyStatus ? (
                <i
                  className="fas fa-check-square cursor-pointer"
                  datatoggle="tooltip"
                  dataplacement="top"
                  title="Copied"
                  style={{ cursor: "pointer" }}
                ></i>
              ) : (
                <i
                  className="fa fa-regular fa-copy cursor-pointer"
                  onClick={() => handleCopy(userInfo.share_link)}
                  datatoggle="tooltip"
                  dataplacement="top"
                  title="Copy"
                  style={{ cursor: "pointer" }}
                />
              )}
            </p>
            <p className="text-white">{userInfo.share_link}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default RXG;
